﻿(() => {
  const header = document.querySelector("[data-site-header]");

  if (header) {
    const menuToggle = header.querySelector("[data-menu-toggle]");
    const nav = header.querySelector("[data-site-nav]");

    if (menuToggle && nav) {
      menuToggle.addEventListener("click", () => {
        const isOpen = nav.classList.toggle("is-open");
        menuToggle.setAttribute("aria-expanded", String(isOpen));
      });
    }

    header.querySelectorAll("[data-dropdown-toggle]").forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const wrapper = toggle.closest(".nav-dropdown");
        const isOpen = wrapper.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", String(isOpen));
      });
    });

    document.addEventListener("click", (event) => {
      if (header.contains(event.target)) return;
      header.querySelectorAll(".nav-dropdown.is-open").forEach((dropdown) => {
        dropdown.classList.remove("is-open");
        const toggle = dropdown.querySelector("[data-dropdown-toggle]");
        if (toggle) toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  document.querySelectorAll("[data-our-work-gallery]").forEach((gallery) => {
    const filters = Array.from(gallery.querySelectorAll("[data-our-work-filter]"));
    const cards = Array.from(gallery.querySelectorAll("[data-project-category]"));
    const noResults = gallery.querySelector("[data-our-work-no-results]");

    const applyProjectFilter = (filter) => {
      let visibleCount = 0;

      filters.forEach((button) => {
        const isActive = button.dataset.ourWorkFilter === filter;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", String(isActive));
      });

      cards.forEach((card) => {
        const isVisible = filter === "all" || card.dataset.projectCategory === filter;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (noResults) noResults.hidden = visibleCount > 0;
    };

    filters.forEach((button) => {
      button.addEventListener("click", () => applyProjectFilter(button.dataset.ourWorkFilter));
    });
  });

  const tracking = window.RJTracking;
  if (tracking) tracking.captureAttribution();
  const quoteParams = new URLSearchParams(window.location.search);
  const adParameterNames = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
  ];

  const dispatchRjEvent = (name, detail = {}) => {
    if (tracking) return tracking.track(name, detail);
    window.dispatchEvent(new CustomEvent(name, { detail }));
    return null;
  };

  const getPageTrackingDetail = () => ({
    page_type: document.body && document.body.dataset ? document.body.dataset.pageType || "" : "",
    page_path: document.body && document.body.dataset
      ? document.body.dataset.pagePath || window.location.pathname || ""
      : window.location.pathname || "",
  });

  const getTrackingDetail = (element) => ({
    source_component: element.dataset.rjSource || element.dataset.rjEvent || "link",
    product_title: element.dataset.rjProductTitle || "",
    product_handle: element.dataset.rjProductHandle || "",
    collection_title: element.dataset.rjCollectionTitle || "",
    collection_handle: element.dataset.rjCollectionHandle || "",
  });

  document.querySelectorAll("[data-rj-event]").forEach((element) => {
    element.addEventListener("click", () => {
      const eventName = element.dataset.rjEvent;
      if (["select_product_category", "select_product", "request_quote_click"].includes(eventName)) {
        dispatchRjEvent(eventName, getTrackingDetail(element));
      }
    });
  });

  document.querySelectorAll('a[href*="/pages/request-a-quote"]:not([data-rj-event])').forEach((link) => {
    link.addEventListener("click", () => {
      dispatchRjEvent("request_quote_click", getTrackingDetail(link));
    });
  });

  document.querySelectorAll('a[href^="mailto:"]').forEach((link) => {
    link.addEventListener("click", () => {
      dispatchRjEvent("click_email", { source_component: link.dataset.rjSource || "contact-link" });
    });
  });

  document.querySelectorAll('a[href^="tel:"]').forEach((link) => {
    link.addEventListener("click", () => {
      dispatchRjEvent("click_phone", { source_component: link.dataset.rjSource || "contact-link" });
    });
  });

  document.querySelectorAll("[data-rj-newsletter-success]").forEach((message) => {
    dispatchRjEvent("newsletter_signup", {
      source_component: message.dataset.rjSource || "newsletter-form",
      ...getPageTrackingDetail(),
    });
    const cleanedUrl = new URL(window.location.href);
    if (cleanedUrl.searchParams.has("customer_posted")) {
      cleanedUrl.searchParams.delete("customer_posted");
      window.history.replaceState(
        window.history.state,
        "",
        `${cleanedUrl.pathname}${cleanedUrl.search}${cleanedUrl.hash}`,
      );
    }
  });

  document.querySelectorAll("[data-rj-optional-fields]").forEach((details) => {
    const summary = details.querySelector("[data-rj-optional-summary]");
    if (!summary) return;
    summary.addEventListener("click", () => {
      if (details.open) return;
      const form = details.closest("form");
      const wrapper = form ? form.closest("[data-rj-quote-form]") : null;
      dispatchRjEvent("quote_form_expand_optional", {
        source_component: wrapper ? wrapper.dataset.rjSource || "quote-form" : "quote-form",
        form_id: form ? form.id || "" : "",
      });
    });
  });

  const adLanding = document.querySelector("[data-rj-ad-landing]");
  if (adLanding || adParameterNames.some((name) => quoteParams.has(name))) {
    dispatchRjEvent("view_ad_landing", {
      source_component: adLanding ? "paid-landing" : "campaign-entry",
      landing_page: window.location.pathname,
    });
  }


  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const mainPanel = gallery.querySelector("[data-product-gallery-main]");
    const mainImage = gallery.querySelector("[data-product-gallery-main-image]");
    const track = gallery.querySelector("[data-product-gallery-track]");
    const thumbnails = Array.from(gallery.querySelectorAll("[data-product-gallery-thumbnail]"));
    const mainPrevButton = gallery.querySelector("[data-product-gallery-main-prev]");
    const mainNextButton = gallery.querySelector("[data-product-gallery-main-next]");
    let activeIndex = 0;

    if (!mainPanel || !mainImage) return;

    const images = thumbnails.length
      ? thumbnails.map((button) => ({
          mainSrc: button.dataset.mainSrc || "",
          mainSrcset: button.dataset.mainSrcset || "",
          alt: button.dataset.alt || mainImage.alt || "",
        }))
      : [{
          mainSrc: mainPanel.dataset.mainSrc || mainImage.currentSrc || mainImage.src,
          mainSrcset: mainPanel.dataset.mainSrcset || mainImage.srcset || "",
          alt: mainPanel.dataset.alt || mainImage.alt || "",
        }];

    if (!images.length) return;

    const setActiveImage = (index, options = {}) => {
      activeIndex = (index + images.length) % images.length;
      const image = images[activeIndex];
      if (!image) return;

      mainImage.src = image.mainSrc;
      mainImage.srcset = image.mainSrcset || "";
      mainImage.alt = image.alt;
      mainPanel.dataset.galleryIndex = String(activeIndex);
      mainPanel.dataset.alt = image.alt;

      thumbnails.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === activeIndex;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-current", String(isActive));
      });

      if (options.scroll !== false && thumbnails[activeIndex]) {
        thumbnails[activeIndex].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
      }
    };

    thumbnails.forEach((button, index) => {
      button.addEventListener("click", () => setActiveImage(index));
    });

    gallery.querySelectorAll("[data-product-gallery-scroll]").forEach((button) => {
      button.addEventListener("click", () => {
        if (!track) return;
        const direction = button.dataset.productGalleryScroll === "prev" ? -1 : 1;
        track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.8, 180), behavior: "smooth" });
      });
    });

    if (mainPrevButton) mainPrevButton.addEventListener("click", () => setActiveImage(activeIndex - 1));
    if (mainNextButton) mainNextButton.addEventListener("click", () => setActiveImage(activeIndex + 1));
  });


  const isQuotePage = window.location.pathname.replace(/\/$/, "") === "/pages/request-a-quote";
  const isThankYouPage = window.location.pathname.replace(/\/$/, "") === "/pages/thank-you";

  if (isQuotePage && quoteParams.get("contact_posted") === "true") {
    const leadToken = tracking ? tracking.getLeadToken() : "";
    const leadQuery = leadToken ? `?lead_token=${encodeURIComponent(leadToken)}` : "";
    window.location.replace(`/pages/thank-you${leadQuery}`);
  }

  if (isThankYouPage && tracking) {
    const leadToken = quoteParams.get("lead_token") || "";
    if (tracking.consumeLeadToken(leadToken)) {
      dispatchRjEvent("generate_lead", { source_component: "thank-you" });
    }
  }

  const quoteProductTitle = quoteParams.get("product_title") || quoteParams.get("product") || "";
  const quoteProductHandle = quoteParams.get("product_handle") || "";
  const quoteCollectionTitle = quoteParams.get("collection_title") || quoteParams.get("collection") || "";
  const quoteCollectionHandle = quoteParams.get("collection_handle") || "";
  const quoteTopic = quoteParams.get("topic") || "";
  const quoteSourceUrl = quoteParams.get("source_url") || "";

  const setQuoteField = (selector, value) => {
    const field = document.querySelector(selector);
    if (field) field.value = value || "";
  };

  setQuoteField("[data-quote-product-field]", quoteProductTitle);
  setQuoteField("[data-quote-collection-field]", quoteCollectionTitle);
  setQuoteField("[data-quote-topic-field]", quoteTopic);
  setQuoteField("[data-quote-source-url-field]", quoteSourceUrl || document.referrer || window.location.href);
  setQuoteField("[data-quote-referrer-field]", document.referrer || "");
  setQuoteField("[data-quote-product-title-field]", quoteProductTitle);
  setQuoteField("[data-quote-product-handle-field]", quoteProductHandle);
  setQuoteField("[data-quote-collection-title-field]", quoteCollectionTitle);
  setQuoteField("[data-quote-collection-handle-field]", quoteCollectionHandle);
  const formAttribution = tracking ? tracking.getFormAttribution() : {};
  Object.entries(formAttribution).forEach(([key, value]) => {
    setQuoteField(`[data-attribution-field="${key}"]`, value);
  });
  setQuoteField("[data-quote-utm-source-field]", formAttribution.last_utm_source || quoteParams.get("utm_source") || "");
  setQuoteField("[data-quote-utm-medium-field]", formAttribution.last_utm_medium || quoteParams.get("utm_medium") || "");
  setQuoteField("[data-quote-utm-campaign-field]", formAttribution.last_utm_campaign || quoteParams.get("utm_campaign") || "");
  setQuoteField("[data-quote-timestamp-field]", new Date().toISOString());

  if (quoteProductTitle || quoteCollectionTitle || quoteTopic) {
    const summary = document.querySelector("[data-quote-source-summary]");
    const summaryTitle = document.querySelector("[data-quote-source-title]");
    const summaryMeta = document.querySelector("[data-quote-source-meta]");
    const apparelSelect = document.querySelector("#QuoteApparel");

    if (summary && summaryTitle) {
      summary.hidden = false;
      if (quoteProductTitle) {
        summaryTitle.textContent = `Selected style: ${quoteProductTitle}`;
      } else if (quoteCollectionTitle) {
        summaryTitle.textContent = `Selected category: ${quoteCollectionTitle}`;
      } else {
        summaryTitle.textContent = `Inquiry topic: ${quoteTopic}`;
      }

      if (summaryMeta) {
        const metaParts = [];
        if (quoteProductTitle && quoteCollectionTitle) metaParts.push(`Category: ${quoteCollectionTitle}`);
        if (quoteTopic) metaParts.push(`Topic: ${quoteTopic}`);
        summaryMeta.textContent = metaParts.join(" | ");
        summaryMeta.hidden = !summaryMeta.textContent;
      }
    }

    if (apparelSelect) {
      const sourceText = `${quoteProductTitle} ${quoteProductHandle} ${quoteCollectionTitle} ${quoteCollectionHandle} ${quoteTopic}`.toLowerCase();
      const apparelMatches = [
        { keys: ["polo"], value: "Polos & Uniform Shirts" },
        { keys: ["hoodie", "sweatshirt"], value: "Hoodies & Sweatshirts" },
        { keys: ["hat", "cap"], value: "Hats & Caps" },
        { keys: ["jacket", "workwear", "vest"], value: "Jackets & Workwear" },
        { keys: ["apron"], value: "Aprons" },
        { keys: ["tote", "bag"], value: "Tote Bags" },
        { keys: ["t-shirt", "shirt", "tee", "dtf"], value: "Event T-Shirts / DTF" },
      ];
      const match = apparelMatches.find((item) => item.keys.some((key) => sourceText.includes(key)));
      if (match) apparelSelect.value = match.value;
    }
  }

  const markQuoteFormStarted = (form) => {
    if (!form || form.dataset.quoteFormStarted === "true") return;
    form.dataset.quoteFormStarted = "true";
    const wrapper = form.closest("[data-rj-quote-form]");
    dispatchRjEvent("quote_form_start", {
      form_id: form.id || "",
      source_component: wrapper ? wrapper.dataset.rjSource || "quote-form" : "quote-form",
    });
  };

  const prepareLeadSubmission = (form) => {
    if (!form) return "";
    let leadToken = form.dataset.leadToken || "";
    if (!leadToken && tracking) {
      leadToken = tracking.createLeadToken();
      form.dataset.leadToken = leadToken;
    }
    const returnTo = form.querySelector("[data-quote-return-to]");
    if (returnTo) {
      returnTo.value = leadToken
        ? `/pages/thank-you?lead_token=${encodeURIComponent(leadToken)}`
        : "/pages/thank-you";
    }
    if (form.dataset.quoteSubmitTracked !== "true") {
      form.dataset.quoteSubmitTracked = "true";
      const wrapper = form.closest("[data-rj-quote-form]");
      dispatchRjEvent("quote_form_submit_attempt", {
        form_id: form.id || "",
        source_component: wrapper ? wrapper.dataset.rjSource || "quote-form" : "quote-form",
      });
    }
    return leadToken;
  };

  const prepareOptionalContactFields = (form) => {
    if (!form) return;
    form.querySelectorAll("[data-optional-contact-field]").forEach((field) => {
      field.disabled = !field.value;
    });
  };

  const setFormBusy = (form, isBusy, message = "") => {
    const submitButton = form.querySelector("[data-submit-button]");
    const formStatus = form.querySelector("[data-form-status]");
    if (submitButton) {
      submitButton.disabled = isBusy;
      submitButton.setAttribute("aria-disabled", String(isBusy));
      submitButton.textContent = isBusy
        ? submitButton.dataset.submitBusyLabel || "Sending your quote request..."
        : submitButton.dataset.submitLabel || "Request My Quote";
    }
    if (formStatus) formStatus.textContent = message;
  };

  const optionalDetailsHasValue = (details) => Array.from(details.querySelectorAll("input, select, textarea")).some((field) => {
    if (field.disabled) return false;
    if (field.type === "file") return Boolean(field.files && field.files.length);
    if (field.type === "radio") return field.checked && !field.hasAttribute("data-rj-default-option");
    if (field.type === "checkbox") return field.checked;
    return Boolean(field.value && String(field.value).trim());
  });

  const expandOptionalDetailsForValidation = (form, invalidFields = []) => {
    const optionalDetails = form.querySelector("[data-rj-optional-fields]");
    if (!optionalDetails) return;
    const hasInvalidOptionalField = invalidFields.some((field) => optionalDetails.contains(field));
    if (hasInvalidOptionalField || optionalDetailsHasValue(optionalDetails)) optionalDetails.open = true;
  };

  const showFormErrors = (form) => {
    const invalidFields = Array.from(form.querySelectorAll(":invalid:not(fieldset):not(form)"));
    const summary = form.querySelector("[data-form-error-summary]");
    const errorList = form.querySelector("[data-form-error-list]");
    if (!invalidFields.length) {
      if (summary) summary.hidden = true;
      return false;
    }

    expandOptionalDetailsForValidation(form, invalidFields);

    invalidFields.forEach((field) => field.setAttribute("aria-invalid", "true"));
    if (summary) {
      summary.hidden = false;
      if (errorList) {
        const list = document.createElement("ul");
        invalidFields.forEach((field) => {
          const item = document.createElement("li");
          const label = field.labels && field.labels.length ? field.labels[0].textContent.trim() : "Required field";
          item.textContent = field.validity && field.validity.valueMissing
            ? `${label.replace(/\s*\*$/, "")} is required.`
            : `${label.replace(/\s*\*$/, "")} needs a valid value.`;
          list.appendChild(item);
        });
        errorList.replaceChildren(list);
      }
    }
    invalidFields[0].focus();
    return true;
  };

  document.querySelectorAll("[data-rj-quote-form] form, #RjQuoteForm").forEach((form) => {
    form.addEventListener("invalid", (event) => {
      expandOptionalDetailsForValidation(form, [event.target]);
    }, true);
    form.addEventListener("input", (event) => {
      markQuoteFormStarted(form);
      if (event.target && event.target.matches("[aria-invalid]") && event.target.validity.valid) {
        event.target.removeAttribute("aria-invalid");
      }
    }, true);
    form.addEventListener("change", () => markQuoteFormStarted(form), true);
    form.addEventListener("submit", (event) => {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setFormBusy(form, false, "Please complete the required fields.");
        showFormErrors(form);
        return;
      }

      const summary = form.querySelector("[data-form-error-summary]");
      if (summary) summary.hidden = true;
      prepareLeadSubmission(form);

      const input = form.querySelector("[data-upload-input]");
      const urlField = form.querySelector("[data-upload-url-field]");
      const hasPendingFile = input && input.files && input.files.length
        && form.dataset.quoteUploadReady !== "true"
        && !(urlField && urlField.value);
      if (!hasPendingFile) {
        setFormBusy(form, true, "Sending your quote request...");
      }
    }, true);
  });

  document.querySelectorAll("[data-rj-newsletter-form] form").forEach((form) => {
    form.addEventListener("submit", (event) => {
      if (!form.checkValidity()) {
        event.preventDefault();
        setFormBusy(form, false, "Please enter a valid email address.");
        return;
      }
      setFormBusy(form, true, "Signing you up...");
    }, true);
  });

  const ALLOWED_UPLOAD_EXTENSIONS = new Set(["ai", "eps", "pdf", "svg", "png", "jpg", "jpeg"]);
  const ALLOWED_UPLOAD_MIME_TYPES = {
    ai: ["application/illustrator", "application/postscript", "application/vnd.adobe.illustrator", "application/octet-stream"],
    eps: ["application/eps", "application/postscript", "application/octet-stream"],
    pdf: ["application/pdf"],
    svg: ["image/svg+xml"],
    png: ["image/png"],
    jpg: ["image/jpeg"],
    jpeg: ["image/jpeg"],
  };

  const validateUploadFile = (file, maxUploadMb) => {
    if (!file) return { valid: true, error_type: "" };
    const extension = file.name && file.name.includes(".") ? file.name.split(".").pop().toLowerCase() : "";
    if (!ALLOWED_UPLOAD_EXTENSIONS.has(extension)) {
      return {
        valid: false,
        error_type: "invalid_extension",
        message: "Please choose an AI, EPS, PDF, SVG, PNG or JPG file.",
      };
    }

    const mimeType = (file.type || "").toLowerCase();
    const allowedMimeTypes = ALLOWED_UPLOAD_MIME_TYPES[extension] || [];
    if (mimeType && !allowedMimeTypes.includes(mimeType)) {
      return {
        valid: false,
        error_type: "invalid_mime_type",
        message: "The selected file type does not match its extension. Please export the logo again and retry.",
      };
    }

    if (file.size > maxUploadMb * 1024 * 1024) {
      return {
        valid: false,
        error_type: "file_too_large",
        message: `Please upload a file smaller than ${maxUploadMb} MB.`,
      };
    }
    return { valid: true, error_type: "" };
  };

  document.querySelectorAll("[data-upload-input]").forEach((input) => {
    input.addEventListener("click", () => {
      dispatchRjEvent("upload_logo_click", {
        form_id: input.form ? input.form.id || "" : "",
        source_component: "quote-logo-upload",
      });
    });

    input.addEventListener("change", () => {
      const field = input.closest(".field");
      const label = field ? field.querySelector("[data-upload-label]") : null;
      const status = field ? field.querySelector("[data-upload-status]") : null;
      const removeButton = field ? field.querySelector("[data-upload-remove]") : null;
      const fileName = input.files && input.files.length ? input.files[0].name : "";
      const wrapper = input.closest("[data-rj-quote-upload]");
      const maxUploadMb = Number(wrapper ? wrapper.dataset.maxUploadMb || 10 : 10);
      const validation = fileName ? validateUploadFile(input.files[0], maxUploadMb) : { valid: true };
      if (label) {
        label.textContent = fileName || "Click to choose a logo file";
      }
      if (removeButton) removeButton.hidden = !fileName;
      if (status) {
        status.textContent = validation.valid
          ? fileName ? "Ready to upload when you submit the form." : ""
          : validation.message;
        status.classList.toggle("is-error", !validation.valid);
        status.classList.remove("is-success");
      }
      if (!validation.valid) {
        dispatchRjEvent("upload_logo_error", {
          form_id: input.form ? input.form.id || "" : "",
          source_component: "quote-logo-upload",
          file_type: input.files[0].type || "unknown",
          error_type: validation.error_type,
        });
      }
    });
  });

  document.querySelectorAll("[data-upload-remove]").forEach((button) => {
    button.addEventListener("click", () => {
      const form = button.closest("form");
      if (!form) return;
      const input = form.querySelector("[data-upload-input]");
      const label = form.querySelector("[data-upload-label]");
      const status = form.querySelector("[data-upload-status]");
      const removeButton = form.querySelector("[data-upload-remove]");
      const urlField = form.querySelector("[data-upload-url-field]");
      const nameField = form.querySelector("[data-upload-name-field]");
      if (input) input.value = "";
      if (urlField) {
        urlField.disabled = false;
        urlField.value = "";
      }
      if (nameField) {
        nameField.disabled = false;
        nameField.value = "";
      }
      if (label) label.textContent = "Click to choose a logo file";
      if (status) {
        status.textContent = "Logo removed. You can submit the quote request without a file.";
        status.classList.remove("is-error", "is-success");
      }
      button.hidden = true;
      delete form.dataset.quoteUploadReady;
      delete form.dataset.quoteUploadPending;
      setFormBusy(form, false, "");
    });
  });

  async function uploadLogoToCloudinary({ file, cloudName, uploadPreset }) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", uploadPreset);

    const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok || !data.secure_url) {
      const message = data.error && data.error.message ? data.error.message : "Logo upload failed.";
      throw new Error(message);
    }

    return {
      url: data.secure_url,
      originalFilename: data.original_filename || file.name,
    };
  }

  document.querySelectorAll("[data-rj-quote-upload]").forEach((uploadWrapper) => {
    const form = uploadWrapper.querySelector("form");
    if (!form) return;

    form.addEventListener("submit", async (event) => {
      const input = form.querySelector("[data-upload-input]");
      const status = form.querySelector("[data-upload-status]");
      const urlField = form.querySelector("[data-upload-url-field]");
      const nameField = form.querySelector("[data-upload-name-field]");
      const removeButton = form.querySelector("[data-upload-remove]");
      const submitButton = form.querySelector('button[type="submit"]');
      const file = input && input.files && input.files.length ? input.files[0] : null;
      const uploadReady = form.dataset.quoteUploadReady === "true";

      if (!file || uploadReady || (urlField && urlField.value)) {
        if (form.checkValidity()) {
          prepareOptionalContactFields(form);
          prepareLeadSubmission(form);
        }
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      prepareLeadSubmission(form);

      if (form.dataset.quoteUploadPending === "true") return;
      form.dataset.quoteUploadPending = "true";

      const cloudName = uploadWrapper.dataset.cloudinaryCloud;
      const uploadPreset = uploadWrapper.dataset.cloudinaryPreset;
      const maxUploadMb = Number(uploadWrapper.dataset.maxUploadMb || 10);
      const validation = validateUploadFile(file, maxUploadMb);

      const restoreSubmitButton = () => {
        if (!submitButton) return;
        submitButton.disabled = false;
        submitButton.setAttribute("aria-disabled", "false");
        submitButton.textContent = submitButton.dataset.submitLabel || submitButton.dataset.originalText || "Request My Quote";
      };

      const setStatus = (message, state) => {
        if (!status) return;
        status.textContent = message;
        status.classList.toggle("is-error", state === "error");
        status.classList.toggle("is-success", state === "success");
      };

      if (!cloudName || !uploadPreset) {
        setStatus("Logo upload is not configured yet. Please contact the studio so we can help with your file.", "error");
        if (removeButton) removeButton.hidden = false;
        dispatchRjEvent("upload_logo_error", {
          form_id: form.id || "",
          source_component: "quote-logo-upload",
          file_type: file.type || "unknown",
          error_type: "upload_not_configured",
        });
        delete form.dataset.quoteUploadPending;
        return;
      }

      if (cloudName === uploadPreset) {
        setStatus("Cloudinary cloud name looks incorrect. It should be your account cloud name, not the upload preset name.", "error");
        if (removeButton) removeButton.hidden = false;
        dispatchRjEvent("upload_logo_error", {
          form_id: form.id || "",
          source_component: "quote-logo-upload",
          file_type: file.type || "unknown",
          error_type: "upload_configuration_error",
        });
        delete form.dataset.quoteUploadPending;
        return;
      }

      if (!validation.valid) {
        setStatus(validation.message, "error");
        if (removeButton) removeButton.hidden = false;
        dispatchRjEvent("upload_logo_error", {
          form_id: form.id || "",
          source_component: "quote-logo-upload",
          file_type: file.type || "unknown",
          error_type: validation.error_type,
        });
        delete form.dataset.quoteUploadPending;
        return;
      }

      try {
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.dataset.originalText = submitButton.textContent;
          submitButton.textContent = "Uploading logo...";
        }

        setStatus("Uploading your logo...", "pending");
        const upload = await uploadLogoToCloudinary({ file, cloudName, uploadPreset });

        if (urlField) urlField.value = upload.url;
        if (nameField) nameField.value = upload.originalFilename || file.name;
        if (removeButton) removeButton.hidden = true;
        setStatus("Logo uploaded. Submitting your quote request...", "success");
        dispatchRjEvent("upload_logo_success", {
          form_id: form.id || "",
          source_component: "quote-logo-upload",
          file_type: file.type || "unknown",
        });
        form.dataset.quoteUploadReady = "true";
        delete form.dataset.quoteUploadPending;

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = "Submitting...";
        }

        prepareOptionalContactFields(form);
        prepareLeadSubmission(form);

        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      } catch (error) {
        setStatus(error.message || "Logo upload failed. Please try again or submit the quote without the file and send it later.", "error");
        if (removeButton) removeButton.hidden = false;
        dispatchRjEvent("upload_logo_error", {
          form_id: form.id || "",
          source_component: "quote-logo-upload",
          file_type: file.type || "unknown",
          error_type: "upload_failed",
        });
        delete form.dataset.quoteUploadPending;
        restoreSubmitButton();
      }
    }, true);
  });
})();
